module.exports = __webpack_public_path__ + "img/005.0c9c0f19.png";